import Vue from 'vue'
import Router from 'vue-router'

import Callback from '../components/Callback.vue';
import Logout from '../components/Logout.vue';
import { authGuard } from '@/auth/authGuard';

// Containers
const TheContainer = () => import('@/containers/TheContainer');

// Views
const Home = () => import('@/views/Home');
const Methodology = () => import('@/views/Methodology');
const Tradeflows = () => import('@/views/Tradeflows');
const PortTradeflows = () => import('@/views/PortTradeflows');
const PortsComparison = () => import('@/views/PortsComparison');
const PortCalls = () => import('@/views/PortCalls');
const LiveStats = () => import('@/views/LiveStats');
const FleetMonitor = () => import('@/views/FleetMonitor');
const LiveMap = () => import('@/views/LiveMap');
const FleetManagement = () => import('@/views/FleetManagement');
const FleetGrowth = () => import('@/views/FleetGrowth');
const Congestion = () => import('@/views/Congestion');
const CongestionOld = () => import('@/views/CongestionOld');
const CongestionSummary = () => import('@/views/CongestionSummary');
const TonnageBasins = () => import('@/views/TonnageBasins');
const TonnageZones = () => import('@/views/TonnageZones');
const TonnageSpeed = () => import('@/views/TonnageSpeed');
const TonnageZoneMap = () => import('@/views/TonnageZoneMap');
const Drydock = () => import('@/views/Drydock');
const DrydockSummary = () => import('@/views/DrydockSummary');
const NotFoundComponent = () => import('@/views/NotFound');
const Expired = () => import('@/views/Expired');
const AccessDenied = () => import('@/views/AccessDenied');
const Profile = () => import('@/views/Profile');
const Terms = () => import('@/views/Terms');
const VesselDetails = () => import('@/views/VesselDetails');


Vue.use(Router);

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      redirect: '/home',
      name: 'Index',
      component: TheContainer,
      children: [
        {
          path: 'home',
          name: 'Home',
          component: Home
        },
        {
          path: 'methodology',
          name: 'Methodology',
          component: Methodology
        },
        {
          path: 'tradeflows',
          name: 'Tradeflows',
          component: Tradeflows
        },
        {
          path: 'port-tradeflows',
          name: 'Port Flows',
          component: PortTradeflows,
        },
        {
          path: 'ports-comparison',
          name: 'Ports Comparison',
          component: PortsComparison,
        },
        {
          path: 'port-calls',
          name: 'Port Calls',
          component: PortCalls,
        },
        {
          path: 'live-stats',
          name: 'Live Stats',
          component: LiveStats,
        },
        {
          path: 'fleet-monitor',
          name: 'Fleet Monitor',
          component: FleetMonitor
        },
        {
          path: 'live-map',
          name: 'Live Map',
          component: LiveMap
        },
        {
          path: 'edit-fleets',
          name: 'Fleet Management',
          component: FleetManagement
        },
        {
          path: 'fleet-growth',
          name: 'Fleet Growth',
          component: FleetGrowth
        },
        {
          path: 'congestion',
          name: 'Congestion (New)',
          component: Congestion
        },
        {
          path: 'congestion-old',
          name: 'Congestion (Old)',
          component: CongestionOld
        },
        {
          path: 'congestion-summary',
          name: 'Congestion Summary',
          component: CongestionSummary
        },
        {
          path: 'profile',
          name: 'Profile',
          component: Profile
        },
        {
          path: 'vessel-details',
          name: 'Vessel Details',
          component: VesselDetails
        },
        {
          path: 'tonnage-basins',
          name: 'Basin Balance',
          component: TonnageBasins
        },
        {
          path: 'tonnage-zones',
          name: 'Tonnage Zones',
          component: TonnageZones
        },
        {
          path: 'tonnage-speed',
          name: 'Fleet Speed',
          component: TonnageSpeed
        },
        {
          path: 'tonnage-zone-map',
          name: 'Zone Map',
          component: TonnageZoneMap
        },
        {
          path: 'drydock',
          name: 'Drydock',
          component: Drydock
        },
        {
          path: 'drydock-summary',
          name: 'Drydock Summary',
          component: DrydockSummary
        },
      ]
    },
    {
      path: "/expired",
      name: "expired",
      component: Expired
    },
    {
      path: "/accessdenied",
      name: "accessdenied",
      component: AccessDenied
    },
    {
      path: "/callback",
      name: "callback",
      component: Callback
    },
    {
      path: "/terms",
      name:"terms",
      component: Terms
    },
    {
      path: "/logout",
      name: "logout",
      component: Logout
    },
    { path: '*', name: "NotFound", component: NotFoundComponent }
  ]
});

router.beforeEach(authGuard);

export default router;
